import { AbstractMouseEvent } from './AbstractMouseEvent';
import { MouseCancelEvent } from './MouseCancelEvent';
import { MouseDownEvent } from './MouseDownEvent';
import { MouseMoveEvent } from './MouseMoveEvent';
import { MousePointerMoveEvent } from './MousePointerMoveEvent';
import { MouseUpEvent } from './MouseUpEvent';
import { ButtonBase } from './ButtonBase';
import { ButtonState } from './ButtonState';
import { EventDispatcher } from './EventDispatcher';
import { EventStream } from './EventStreamSubscription';
import { SceneObjectType } from './SceneObjectType';

export class Button extends ButtonBase {
  get runtimeType(): SceneObjectType {
    return SceneObjectType.Button;
  }

  private _mouseEnteredDispatcher = new EventDispatcher<Button>();
  private _mouseLeftDispatcher = new EventDispatcher<Button>();

  get mouseEntered(): EventStream<Button> {
    return this._mouseEnteredDispatcher.eventStream;
  }

  get mouseLeft(): EventStream<Button> {
    return this._mouseLeftDispatcher.eventStream;
  }

  onTouch(e: AbstractMouseEvent): void {
    super.onTouch(e);

    if (e instanceof MouseDownEvent) {
      const inside = this.isInPoint(e.event.location);
      if (inside) {
        this.state = ButtonState.Down;
        e.accept();
      }
    } else if (e instanceof MouseCancelEvent) {
      this.state = ButtonState.Normal;
      e.accept();
    } else if (e instanceof MouseMoveEvent) {
      const inside = this.isInPoint(e.moveEvent.location);
      if (inside && this.state === ButtonState.Down) {
        this.state = ButtonState.Down;
        e.accept();
      } else {
        this.state = ButtonState.Normal;
      }
    } else if (e instanceof MousePointerMoveEvent) {
      const inside = this.isInPoint(e.event.location);
      if (inside && this.state === ButtonState.Normal) {
        this._mouseEnteredDispatcher.dispatchEvent(this);
        this.state = ButtonState.Hover;
      } else if (!inside && (this.state === ButtonState.Down || this.state === ButtonState.Hover)) {
        this._mouseLeftDispatcher.dispatchEvent(this);
        this.state = ButtonState.Normal;
      }
    } else if (e instanceof MouseUpEvent) {
      const inside = this.isInPoint(e.upEvent.location);
      if (this.state === ButtonState.Down) {
        this.state = inside ? ButtonState.Hover : ButtonState.Normal;
        this.dispatchClick();
      }
      e.accept();
    }
  }
}
